import Heading from "@afa-shared/afa-components/dist/Heading";
import Text from "@afa-shared/afa-components/dist/Text";
import { StandardLink } from "@components/Link/StandardLink";
import { PaymentDay } from "contexts/PaymentDaysContext";

import { Context } from "types/context/Context";

import paymentDaysBlockStyles from "./PaymentDaysBlock.module.css";
import { getClosestPaymentDayAsObject } from "./paymentDaysHelper";
import { PaymentDaysBlockType_paymentDaysBlock } from "./queries/contentfulTypes/PaymentDaysBlockType";

interface PaymentDayTeaserRow {
  paymentDays: PaymentDay[];
  label: string;
}

interface PaymentDaysTeaserListProps {
  rows: PaymentDayTeaserRow[];
  blockData: PaymentDaysBlockType_paymentDaysBlock;
  context?: Context;
  showLink?: boolean;
  linkText?: string;
  linkUrl?: string;
}

export const PaymentDaysTeaserList = ({
  rows,
  blockData,
  context,
  showLink = false,
  linkText = "",
  linkUrl = "",
}: PaymentDaysTeaserListProps) => {
  return (
    <div
      className={paymentDaysBlockStyles.puffList}
      data-contentful-entry-id={blockData.sys?.id}
      data-contentful-field-id="name"
    >
      <div className={paymentDaysBlockStyles.puffListContentWrapper}>
        <Heading variant="h2" as={context?.heading?.parentLevel} removeMargin>
          {blockData?.heading}
        </Heading>
        <div className={paymentDaysBlockStyles.puffListRows}>
          {rows.map(({ paymentDays, label }, index) => {
            const closestDay = getClosestPaymentDayAsObject(paymentDays);
            if (!closestDay) return null;
            return (
              <div key={index} className={paymentDaysBlockStyles.puffListRow}>
                <div className={paymentDaysBlockStyles.puffListDateBox}>
                  <Text
                    variant="paragraph"
                    className={paymentDaysBlockStyles.puffListDayNumber}
                    aria-hidden="true"
                  >
                    {closestDay.dayOfMonth}
                  </Text>
                  <Text
                    variant="paragraph"
                    className={`${paymentDaysBlockStyles.puffListMonth} ${paymentDaysBlockStyles.capitalize}`}
                    aria-hidden="true"
                  >
                    {closestDay.month}
                  </Text>
                </div>
                <div
                  className={paymentDaysBlockStyles.puffListLabel}
                  aria-label={`${closestDay.dayOfMonth} ${closestDay.month} - ${label}`}
                >
                  <Text variant="paragraph">{label}</Text>
                </div>
              </div>
            );
          })}
        </div>
        {showLink && linkText && linkUrl && (
          <StandardLink
            href={linkUrl}
            text={linkText}
            variant="link"
            type="arrow_forward"
            className={paymentDaysBlockStyles.puffListAllLink}
          />
        )}
      </div>
    </div>
  );
};

export default PaymentDaysTeaserList;
